export default "__VITE_ASSET__DUR0zZz9__"